module.exports = __webpack_public_path__ + "img/icon-screen-small.b75f2c23.svg";